import script from "./AddStudent.vue?vue&type=script&setup=true&lang=js"
export * from "./AddStudent.vue?vue&type=script&setup=true&lang=js"

import "./AddStudent.vue?vue&type=style&index=0&id=dc8b684a&lang=css"

const __exports__ = script;

export default __exports__